export default __webpack_public_path__ + "static/media/q.a482b3f9.wav";